/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 */

import React from 'react';
import { SvgIcon } from '@material-ui/core';

const AlertIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.10394 1.63069L15.8257 13.0886C16.1814 13.6949 15.9754 14.4731 15.3657 14.8268C15.1702 14.9402 14.9479 14.9999 14.7216 14.9999H1.27815C0.572247 14.9999 0 14.4309 0 13.729C0 13.504 0.0600838 13.283 0.174111 13.0886L6.89586 1.63069C7.25154 1.02439 8.03417 0.819598 8.64392 1.17327C8.83437 1.28374 8.99284 1.44132 9.10394 1.63069ZM7.5 5.99994C7.22386 5.99994 7 6.2238 7 6.49994V9.49994C7 9.77608 7.22386 9.99994 7.5 9.99994H8.5C8.77614 9.99994 9 9.77608 9 9.49994V6.49994C9 6.2238 8.77614 5.99994 8.5 5.99994H7.5ZM7.5 10.9999C7.22386 10.9999 7 11.2238 7 11.4999V12.4999C7 12.7761 7.22386 12.9999 7.5 12.9999H8.5C8.77614 12.9999 9 12.7761 9 12.4999V11.4999C9 11.2238 8.77614 10.9999 8.5 10.9999H7.5Z"
      fill="#B20900"
    />
  </SvgIcon>
);

export default AlertIcon;
